<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<!--车辆监控页面_右侧tab面板之车辆紧急预警开始-->
	<dl>
		<dt class="emergency"><span>（{{emgNum}}）个紧急预警</span><em class="em_a">-</em> <em class="em_b">+</em></dt>
		<dd>
			<ul>
				<li v-for="(alarmInfo,index) in alarmInfoList.list">
					<p>预警号：AL{{alarmInfo.id}} | 于{{alarmInfo.almTime}}</p>
					<p>{{alarmInfo.almTypeName}} | {{alarmInfo.planName}}</p>
					<p>{{alarmInfo.vehicleAccount}} <span>{{alarmInfo.plateNumber}}</span></p>
					<em>{{alarmInfo.almMessage}}</em>
					<p>
						<i @click.stop="locating(alarmInfo.deviceId)"><a>定位</a></i>
						<i @click.stop="alarmLive(alarmInfo.id,alarmInfo.vehicleId)"><a>现场</a>
										</i>
						<i @click.stop="checkTop({id:alarmInfo.id,type:1,pageNo:alarmInfoList.pageNum,top:alarmInfo.isStick})"><a>{{alarmInfo.isStick===1?'已置顶':'置顶'}}</a></i>
						<i @click.stop="handleAlarm(alarmInfo.id,1)"><a>{{alarmInfo.handleStatus==0?'处理':'已处理'}}</a></i>
					</p>
				</li>
			</ul>
			<!--分页组件-->
			<laypage :pages="pagesTotal" v-on:changePage="cb1" :groups="pagesTotal > 3 ? 3 : pagesTotal" :first="first" :last="last" :prev="prev" :next="next" class="laypage"></laypage>
		</dd>
	</dl>

	<!--车辆监控页面_右侧tab面板之车辆预警结束-->
</template>
<script>
	import {
		mapState
	} from 'vuex'
	import Laypage from 'components/common/vueLaypage/Laypage'
	export default {
		name: 'VehicleAlarmEmg',
		components: {
			Laypage
		},
		data() {
			return {
				permission: this.$store.state.permission.permission["vehicleMonitor"] ? this.$store.state.permission.permission["vehicleMonitor"] : [], 
				handleStatus:'处理',
				//获取预警信息参数
				param: {
					almLevel: 1,
					planOwnerType: 1,
					page_index: 1
				},
				topStatus: '',
				isTop: false,
				alarmInfoList: [],
				pagesTotal: 0, //总页数
				first: false, //不显示首页
				last: false, //不显示尾页
				prev: '上一页',
				next: '下一页'
			}
		},
		props:['emgNum'],
		computed: mapState({
			alarmList: state => state.monitor.alarmList,
			alarmNum: state => state.monitor.alarmNum
		}),
		watch: { 
			alarmList(val) {
				if(val) {
					this.pagesTotal = val.pages
					this.alarmInfoList = val;
				}
			}
		},
		methods: {
			cb1(page) { //分页组件回调
				this.param.almLevel = 1;
				this.param.page_index = page
				this.$store.dispatch('showAlarmInfo', this.param)
			},
			locating(id) { //点击定位
				const param = {
					deviceId: id
				}
				this.$store.dispatch('locateOne', param)
			},
			alarmLive(msgId, vId) { //点击进入预警现场
				//1，进入轨迹回放tab
				const obj = {
					name: '车辆轨迹回放',
					code: 'vehicleTrace',
					id: 'PageVehicleTrace',
					route: '/indexhome/vehicleTrace',
					No: 'vehicleTrace'
				}
				this.addTab(obj)
					//2,追加预警现场队列
				const param = {
					almMsgId: msgId,
					vehicleId: vId
				}
				this.$store.dispatch('addAlarmLive', param)
			},
			addTab(obj) { //进入tab窗口
				this.$router.push(obj.route);
				this.$store.dispatch('addTab', obj);
			},
			handleAlarm(id, almType) { //点击处理预警
				const obj = {
					alarmId: id,
					alarmType: almType,
					source:'monitor'
				}
				this.$store.dispatch('getAlarmDetail', obj)
			},
			checkTop(obj) { //置顶某条预警信息
				const param = {
						msgId: obj.id,
						almLevel: obj.type,
						planOwnerType: 1,
						page_index: obj.pageNo
					}
				if(obj.top === 1) {
					this.removeTop(param)
				}else if(obj.top === 0) {
					this.stickTop(param)
				}else{
					return false;
				}
			},
			stickTop(param) { //置顶
				this.$http.post(process.env.API_ROOT + '/alarm/alarms/sticks', param)
					.then((res) => {
						this.alarmInfoList = res.body.data;
						this.$store.dispatch('tipModalShow','置顶成功')
					}, (res) => {
						this.$store.dispatch('tipModalShow',res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow','请求异常')
					})
			},
			removeTop(param) { //取消置顶
				this.$http.delete(process.env.API_ROOT + '/alarm/alarms/sticks', {
						body: param
					})
					.then((res) => {
						this.alarmInfoList = res.body.data;
						this.$store.dispatch('tipModalShow','取消置顶成功')
					}, (res) => {
						this.$store.dispatch('tipModalShow',res.body.message)
					})
					.catch((res) => {
						this.$store.dispatch('tipModalShow','请求异常')
					})
			}
		}

	}
</script>


// WEBPACK FOOTER //
// VehicleAlarmEmg.vue?5f65cae0